import styled from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';

export const MEDIA = {
    tablet: 'max-width: 1279px',
    mobile: 'max-width: 639px',
};

export const Footer = styled.div`
    display: block;
    width: 100%;
    background: ${COLORS.outlineGrey};
    padding-top: 46px;
    padding-bottom: 36px;
    margin-top: 50px;

    @media(${MEDIA.tablet}) {
        padding: 34px 0;
    }

    @media(${MEDIA.mobile}) {
        padding: 16px 0;
    }
`;

export const FooterTop = styled.div`
    display: grid;
    grid-template-columns: 45% 55%;

    @media(${MEDIA.tablet}) {
        display: block;
    }

    @media(${MEDIA.mobile}) {
    }
`;

export const FooterBottom = styled.div`
    display: block;
    border-top: 1px solid #D8D8D8;
    padding-top: 36px;

    @media(${MEDIA.tablet}) {
        border-top: none;
        padding-top: 0;
    }

    @media(${MEDIA.mobile}) {
    }
`;

export const Wrap = styled.div`
    display: block;
    max-width: 1644px;
    padding: 0 8.4%;
    margin: 0 auto;

    @media(${MEDIA.tablet}) {
        padding: 0 5.3%;
    }

    @media(${MEDIA.mobile}) {
        padding: 0 16px;
    }
`;

export const FooterSupport = styled.div`
    display: block;
    border-right: 1px solid #D8D8D8;
    padding: 0 42px 24px 0;

    @media(${MEDIA.tablet}) {
        padding: 0 0 48px 0;
        border-right: none;
    }

    @media(${MEDIA.mobile}) {
        padding: 0 0 56px 0;
    }
`;

export const FooterService = styled.div`
    display: block;
    padding: 0 0 24px 16.4%;

    @media(${MEDIA.tablet}) {
        padding: 0 0 34px 0;
    }

    @media(${MEDIA.mobile}) {
        padding: 0 0 24px 0;
    }
`;

export const FooterCopyringht = styled.div`
    display: block;
`;


export const FooterStyled = styled.div`
    display: initial;
    width: 100%;
    background: ${COLORS.outlineGrey};
`;
export const FooterWrapper = styled.div`
    display: block;

    padding-top: 46px;
    padding-bottom: 36px;
    max-width: 1346px;
    margin-left: auto;
    margin-right: auto;

    @media(${MEDIA.tablet}) {
        max-width: none;
    }
`;

export const ViewInMobile = styled.div`
    display: none;
    
    @media(${MEDIA.mobile}) {
        display: block;
        margin-bottom: 32px;
    }
`;

export const LinksWrap = styled.div`
    display: flex;
    justify-content: space-between;

    @media(${MEDIA.tablet}) {
        justify-content: flex-start;
        max-width: none;

        & > *:not(:last-child) {
            margin-right: 80px;
        }
    }

    @media(${MEDIA.mobile}) {
        & > *:not(:last-child) {
            margin-right: initial;
        }

        & > * {
            flex: 100% 1 0;
            margin-bottom: 16px;
        }

        & > *:nth-child(1),
        & > *:nth-child(2) {
            flex: 50% 1 0;
        }
    }
`;

export const Copyright = styled.div`
    display: grid;
    grid-template-columns: 45% 55%;
    padding: 42px 0 36px;

    @media(${MEDIA.tablet}) {
        padding: 24px 0 34px 0;
        grid-template-columns: 210px 1fr;
        grid-gap: 55px;
    }

    @media(${MEDIA.mobile}) {
        padding: 24px 0;
        grid-template-columns: 1fr;
        grid-gap: 28px;
    }
`;

export const CopyrightCompany = styled.p`
    color: ${COLORS.middleGray};
    font-size: 14px;
    line-height: 18px;
    font-weight: 300;
`;

export const CopyrightText = styled.p`
    padding-left: 16.4%;
    max-width: 600px;
    font-weight: 300;
    font-size: 14px;
    line-height: 18px;
    color: ${COLORS.middleGray};

    @media(${MEDIA.tablet}) {
        padding-left: initial;
    }
`;

export const FooterText = styled.p`
    margin: 0;
    padding: 0 0 30px;
`;

export const CopyrightLink = styled.a`
    border-bottom: 1px solid currentColor;
    color: currentColor;
    transition: 0.25s;
    
    &:hover {
        color: ${COLORS.black};
    }
`;

export const Store = styled.div`
    margin-top: 34px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;

    & > *:nth-child(1) {
        flex: 188px 0 1;
        margin-right: auto;
    }

    & > *:nth-child(2) {
        margin-left: 16px;
        margin-right: 16px;
    }

    & > *:nth-child(2),
    & > *:nth-child(3) {
        flex: 134px 0 1;
    }
    
    @media(${MEDIA.tablet}) {
    }

    @media(${MEDIA.mobile}) {
        margin-top: 16px;

        & > *:nth-child(1) {
            display: none;
        }
    
        & > *:nth-child(2) {
            margin-left: 0;
            margin-right: 16px;
        }
    }
`;

export const PayBtn = styled.a`
`;
export const CompanyService = styled.div`
    display: block;
    position: relative;
    
`;
export const SocialContainer = styled.div`
    display: flex;
    align-items: center;

    ul {
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    li:not(:last-child) {
        margin-right: 8px;
    }

    a {
        width: 24px;
        height: 24px;
    }

    @media(${MEDIA.mobile}) {
        display: block;
    }
`;

export const SocialText = styled.div`
    font-size: 14px;
    line-height: 18px;
    margin-right: 16px;

    @media(${MEDIA.mobile}) {
        margin: 0 0 8px 0;
    }
`;
